import Vue from 'vue'
import Router from 'vue-router'
import Home from "../views/Home"
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  },
  {
    path: '/product',
    name: 'Product',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/Product.vue')
    }
  },
  {
    path: '/IndustryCase',
    name: 'IndustryCase',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/IndustryCase.vue')
    }
  },
  {
    path: '/ContactUs',
    name: 'ContactUs',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ContactUs.vue')
    }
  },
  {
    path: '/News',
    name: 'News',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/News.vue')
    }
  },
  {
    path: '/ProductDetails',
    name: 'ProductDetails',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ProductDetails.vue')
    }
  },
  {
    path: '/NewsDetails',
    name: 'NewsDetails',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/NewsDetails.vue')
    }
  },
  {
    path: '/IndustryCaseDetails',
    name: 'IndustryCaseDetails',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/IndustryCaseDetails.vue')
    }
  }
]

const router = new Router({
  // mode: 'history',
  scrollBehavior(to,from,saveTop){

    if(saveTop){
    
    return saveTop;
    
    }else{
    
    return {x:0,y:0}
    
    } },
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js